import { ALLOWED_ATTACHMENT_SIZE, ALLOWED_ATTACHMENT_TYPES } from 'consts/consts';
import { attachment as attachmentBtn } from 'icons/attachment.js';

export const AttachmentsTemplate = (model) => {
	/*html*/
	const html = `
        <button
            id="engtAttachmentBtn"
            class="engt-btn-icons engt-tab-selectable engt-reply-btns"
            aria-label="Upload attachment"
            onclick="getElementById('engtAttachmentInput').click()"
        >
            <input type="file" id="engtAttachmentInput" name="filename" onclick="this.value = null;" style="display: none;" 
                accept="${ALLOWED_ATTACHMENT_TYPES}"
                size="${ALLOWED_ATTACHMENT_SIZE}">
            ${attachmentBtn()}
        </button>
    `;

	return html;
};
